import React, {useEffect, useState} from 'react';
import {
  UseFormRegister,
  UseFormSetValue,
  UseFormClearErrors,
} from 'react-hook-form';
import PlacesAutocomplete from 'react-places-autocomplete';

import IRules from '../../../interfaces/IRules';
import IInputs from '../../../interfaces/IInputs';

import './AutoloadSelect.sass';

interface Props {
  inputName: 'city' | 'location';
  label: string;
  subLabel?: string;
  placeholder: string;
  register: UseFormRegister<IInputs>;
  setValue: UseFormSetValue<IInputs>;
  clearErrors: UseFormClearErrors<IInputs>;
  rules: IRules;
  required?: boolean;
  isFormSubmitted: boolean;
  invalid?: boolean;
  valid?: boolean;
}

function CityInput({
   label,
   subLabel,
   inputName,
   required,
   rules,
   register,
   setValue,
   clearErrors,
   placeholder,
   isFormSubmitted,
   invalid,
   valid,
 }: Props) {
  const [address, setAddress] = useState('');

  const handleChange = (addressInput: string) => {
    setAddress(addressInput);
    setValue(inputName, addressInput);
    clearErrors([inputName]);
  };

  // const onError = () => {
  // 	console.log('Put invalid input');
  // 	setAddress('');
  // };

  useEffect(() => {
  }, [invalid, valid]);

  useEffect(() => {
    setAddress('');
  }, [isFormSubmitted]);
  return (
    <>
      <PlacesAutocomplete
        // onError={() => onError()}
        value={address || ''}
        onChange={(value) => handleChange(value)}
        onSelect={(value) => handleChange(value)}
        searchOptions={{types: ['(cities)']}}
      >
        {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
          <div
            className={`${invalid ? ' invalid' : ''}${valid ? ' valid' : ''}`}
          >
            <div className="input-row">
              <label htmlFor="city" className="form-label">
                {label} {required && '*'}
              </label>
              <label htmlFor="city" className="form-label">
                {subLabel}
              </label>
              <input
                {...getInputProps({
                  placeholder,
                  className: `input-default${invalid ? ' invalid' : ''}${
                    valid ? ' valid' : ''
                  }`,
                })}
              />
            </div>
            <div className="autoload-select">
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion, i) => {
                // console.log(suggestion);
                const className = suggestion.active
                  ? 'autoload-select-item autoload-select-item--active'
                  : 'autoload-select-item';
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                    })}
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      <input type="hidden" {...register(inputName, rules)} />
    </>
  );
}

CityInput.defaultProps = {
  required: false,
  valid: false,
  invalid: false,
};
export default CityInput;
